import React from "react";

export default function CertificadoDescargar({ datosCurso, onClose }) {
  return (
    <div className="tarjeta-certificado-descargar" data-figma-id="1976:34429">
      <div className="frame-290224">
        <div className="frame-290223">
          <div className="frame-290220">
            <p className="certificado">Certificado</p>
            <p className="derivador-futuros-forwards-opciones-y-swaps-2">
              Derivador: Futuros, Forwards, Opciones y Swaps
            </p>
          </div>
          <div className="frame-290221">
            <p className="no-certificado-04567-nmx">
              No. certificado: 04567-NMX
            </p>
            <p className="obtenido-el-7-de-febrero-de-2024">
              Obtenido el: 7 de Febrero de 2024
            </p>
          </div>
        </div>
        <div className="frame-290222">
          <button className="boton-cerrar-certificado" onClick={onClose}>Cerrar</button>
          <button className="boton-descargar-certificado">
            Descargar certificado
          </button>
        </div>
      </div>
      <img
        className="frame-25"
        src="../images/Frame-25.png"
        alt="Certificado"
        loading="lazy"
        data-figma-id="1976:34422"
      />
    </div>
  );
}
